import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  airportName: {},
  isLoading: false,
  error: "",
  hasData: false,
  airportNameStatus: {
    status: false,
    message: ""
  }
};
const airportNameSlice = createSlice({
  name: "airportNames",
  initialState,
  reducers: {
    airportNameRequest: state => {
      state.isLoading = true;
    },
    airportNameSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.airportName = action.payload;
      state.airportNameStatus.status = true;
    },
    airportNameFailure: (state, action) => {
      state.error = action.payload;
      state.airportName = "";
      state.isLoading = false;
      state.airportNameStatus.status = false;
    }
  }
});
export const {
  airportNameRequest,
  airportNameSuccess,
  airportNameFailure
} = airportNameSlice.actions;
export default airportNameSlice.reducer;